import { styled } from "styled-components";
import { layoutPadding } from "~/styles/mixins";

export const StyledCartPage = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.black};
  margin-top: ${({ theme }) => theme.space[40]};
`;

export const SubtotalWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.space[32]};
  margin-top: ${({ theme }) => theme.space[4]};

  ${({ theme }) => theme.breakpoints.up("desktop")} {
    margin-bottom: ${({ theme }) => theme.space[16]};
  }
`;

export const ContentWrapper = styled.div`
  ${layoutPadding};
  padding-top: ${({ theme }) => theme.space[16]};
`;

export const CheckoutButton = styled.a`
  display: block;
`;
